import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import EditItems from './views/EditItems.vue'
import Login from './views/Login.vue'
import Item from './views/Item.vue'
import Items from './views/Items.vue'
import Customer from './views/Customer.vue'
import NewCustomer from './views/NewCustomer.vue'
import Locations from './views/Locations.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/editItems',
      name: 'EditItems',
      component: EditItems
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/item/:itemId',
      name: 'Item',
      component: Item
    },
    {
      path: '/items',
      name: 'Items',
      component: Items
    },
    {
      path: '/customer/:customerId',
      name: 'Customer',
      component: Customer
    },
    {
      path: '/customers',
      name: 'NewCustomer',
      component: NewCustomer
    },
    {
      path: '/locations',
      name: 'Locations',
      component: Locations
    }
  ]
})
